// Extended tour catalogue — 12 full packages each for Sikkim, Arunachal Pradesh,
// Meghalaya and Bhutan, plus matching "sample itinerary" cards for the four
// destination pages. B2B: no prices; net agent rates shared on enquiry.

// 12 unique premium images per region (no image is reused across packages).
const IMG_LIST = {
  sikkim: [
    "https://images.unsplash.com/photo-1645033393637-9089ab100756?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.unsplash.com/photo-1617554658760-5d8f6882caf9?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.unsplash.com/photo-1696388882435-4a8a116dff2c?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.unsplash.com/photo-1645033393602-4f7623917853?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.pexels.com/photos/17937691/pexels-photo-17937691.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
    "https://images.pexels.com/photos/33262252/pexels-photo-33262252.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
    "https://images.pexels.com/photos/30156563/pexels-photo-30156563.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
    "https://images.pexels.com/photos/38201348/pexels-photo-38201348.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
    "https://images.unsplash.com/photo-1689499858674-8bbcc50708e1?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.pexels.com/photos/31403072/pexels-photo-31403072.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
    "https://images.unsplash.com/photo-1677593570180-8bc67bb575b0?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.pexels.com/photos/35040513/pexels-photo-35040513.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
  ],
  arunachal: [
    "https://images.unsplash.com/photo-1668437824006-1be44600774b?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.unsplash.com/photo-1628070018796-a9f4e2dd482a?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.unsplash.com/photo-1628070031852-5d3080b6e905?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.unsplash.com/photo-1600402808924-9c591a6dace8?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.unsplash.com/photo-1632648196197-03d10a183307?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.unsplash.com/photo-1753952969735-9be9feb9a217?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.pexels.com/photos/5201146/pexels-photo-5201146.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
    "https://images.unsplash.com/photo-1753120709457-c04872420861?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.pexels.com/photos/5015007/pexels-photo-5015007.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
    "https://images.unsplash.com/photo-1619282401041-56e69dcc5335?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.unsplash.com/photo-1718900214997-46507a404978?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.pexels.com/photos/31307365/pexels-photo-31307365.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
  ],
  meghalaya: [
    "https://images.unsplash.com/photo-1687555821474-c0b2ed52a558?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.pexels.com/photos/28051279/pexels-photo-28051279.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
    "https://images.pexels.com/photos/12233686/pexels-photo-12233686.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
    "https://images.pexels.com/photos/27820314/pexels-photo-27820314.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
    "https://images.pexels.com/photos/10101268/pexels-photo-10101268.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
    "https://images.pexels.com/photos/945593/pexels-photo-945593.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
    "https://images.unsplash.com/photo-1674420272199-8d929412a897?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.unsplash.com/photo-1552978534-9d01e1f91517?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.pexels.com/photos/33769041/pexels-photo-33769041.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
    "https://images.pexels.com/photos/11622977/pexels-photo-11622977.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
    "https://images.unsplash.com/photo-1566076009300-e313adb6f2a7?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.unsplash.com/photo-1681009980126-cf9160a331a5?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
  ],
  bhutan: [
    "https://images.unsplash.com/photo-1772203275361-a8761630f8bc?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.unsplash.com/photo-1761048152533-c9461a31d4bb?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.unsplash.com/photo-1772203228933-2d0f06bc36e7?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.unsplash.com/photo-1782875899189-2e7a4d6342a8?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.unsplash.com/photo-1670992493225-e6a76acaca83?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.unsplash.com/photo-1733517766086-5bb8f2ffd2f8?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.unsplash.com/photo-1769726382906-d0b7726f52c6?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.pexels.com/photos/20724436/pexels-photo-20724436.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
    "https://images.unsplash.com/photo-1762632159518-b039c63be8b0?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.unsplash.com/photo-1665730365086-244792392a21?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.unsplash.com/photo-1639623535072-2e53900258af?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    "https://images.unsplash.com/photo-1584003734930-b12779f66351?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
  ],
};

const _imgCounter = {};
function nextImg(region) {
  const i = (_imgCounter[region] = _imgCounter[region] || 0);
  _imgCounter[region] = i + 1;
  const list = IMG_LIST[region];
  return list[i % list.length];
}

const INC_NE = [
  "Hand-picked hotels & homestays",
  "All transfers by private vehicle",
  "Daily breakfast (and dinner on remote legs)",
  "Experienced local driver-cum-guide",
  "All applicable permits (ILP/PAP) & taxes",
];
const EXC_NE = [
  "Flights & train fares",
  "Lunches & most dinners",
  "Entry, camera & activity fees",
  "Personal expenses & tips",
];
const INC_BT = [
  "3-star+ hotels across Bhutan",
  "Bhutan visa & Sustainable Development Fee (SDF)",
  "Licensed Bhutanese guide & private driver",
  "All meals — breakfast, lunch & dinner",
  "All monument, museum & permit fees",
];
const EXC_BT = [
  "International flights to/from Paro",
  "Beverages & personal expenses",
  "Travel insurance",
  "Tips & gratuities",
];
const NOTE = "Per person on twin-sharing. Fully customisable dates, pace and hotels — net agent rates shared on enquiry.";

// helper to build a package + detail from compact data
function mk(region, regionLabel, imgIdx, slug, title, days, tags, summary, overview, itinerary, inc, exc) {
  return {
    list: { slug, title, days, region: regionLabel, tags, image: nextImg(region), summary },
    detail: { overview: [overview], itinerary, inclusions: inc, exclusions: exc, priceNote: NOTE },
  };
}

const DEFS = [
  // ---------------- SIKKIM ----------------
  mk("sikkim", "Sikkim", 0, "sikkim-gangtok-tsomgo-getaway", "Gangtok & Tsomgo Lake Getaway", "3 Nights / 4 Days", ["Gangtok", "Tsomgo Lake", "MG Marg"],
    "A short, scenic first taste of Sikkim — the capital Gangtok and the glacial Tsomgo Lake.",
    "A relaxed long-weekend circuit around Gangtok with the glacial Tsomgo Lake and Baba Mandir day trip.",
    [
      { day: 1, title: "Arrive Gangtok", desc: "Transfer from Bagdogra/NJP (~4 hrs); evening stroll on MG Marg." },
      { day: 2, title: "Tsomgo Lake & Baba Mandir", desc: "Day excursion to the sacred glacial lake and Baba Harbhajan Singh temple." },
      { day: 3, title: "Gangtok sightseeing", desc: "Rumtek Monastery, Ropeway, Ganesh Tok and Hanuman Tok." },
      { day: 4, title: "Departure", desc: "Transfer to Bagdogra/NJP for your onward journey." },
    ], INC_NE, EXC_NE),
  mk("sikkim", "Sikkim", 1, "sikkim-north-lachung-lachen", "North Sikkim: Lachung & Lachen", "5 Nights / 6 Days", ["Lachung", "Lachen", "Chopta Valley"],
    "The dramatic north — Lachung, Lachen and the alpine valleys along the Teesta.",
    "A journey into remote North Sikkim, staying in the twin hamlets of Lachung and Lachen amid snow peaks.",
    [
      { day: 1, title: "Arrive Gangtok", desc: "Transfer from the plains; evening at leisure on MG Marg." },
      { day: 2, title: "Drive to Lachung", desc: "Scenic Teesta-river drive past waterfalls to the Lachung valley." },
      { day: 3, title: "Yumthang & back to Lachen", desc: "Yumthang Valley and Zero Point, then transfer to Lachen." },
      { day: 4, title: "Chopta Valley", desc: "Explore the alpine Chopta Valley and Thangu region." },
      { day: 5, title: "Return to Gangtok", desc: "Drive back to the capital; free evening." },
      { day: 6, title: "Departure", desc: "Transfer to Bagdogra/NJP." },
    ], INC_NE, EXC_NE),
  mk("sikkim", "Sikkim", 0, "sikkim-yumthang-valley-flowers", "Yumthang Valley of Flowers", "5 Nights / 6 Days", ["Yumthang", "Rhododendrons", "Zero Point"],
    "Sikkim's Valley of Flowers in bloom, framed by snow peaks and hot springs.",
    "Time your trip to the rhododendron bloom in the Yumthang 'Valley of Flowers' with a run up to Zero Point.",
    [
      { day: 1, title: "Arrive Gangtok", desc: "Transfer from Bagdogra/NJP; evening on MG Marg." },
      { day: 2, title: "Drive to Lachung", desc: "Waterfall-lined drive into the northern valleys." },
      { day: 3, title: "Yumthang & Zero Point", desc: "Valley of Flowers, hot springs and the snowline at Zero Point." },
      { day: 4, title: "Return to Gangtok", desc: "Drive back with photo stops along the Teesta." },
      { day: 5, title: "Gangtok sightseeing", desc: "Rumtek Monastery and the city's viewpoints." },
      { day: 6, title: "Departure", desc: "Transfer to Bagdogra/NJP." },
    ], INC_NE, EXC_NE),
  mk("sikkim", "Sikkim", 1, "sikkim-gurudongmar-expedition", "Gurudongmar Lake Expedition", "6 Nights / 7 Days", ["Gurudongmar", "Lachen", "High Altitude"],
    "The sacred, mirror-still Gurudongmar Lake at 17,800ft near the Tibetan frontier.",
    "A high-altitude expedition to the sacred Gurudongmar Lake, one of the highest lakes on earth.",
    [
      { day: 1, title: "Arrive Gangtok", desc: "Transfer from the plains; acclimatisation evening." },
      { day: 2, title: "Drive to Lachen", desc: "Long, scenic drive north along the Teesta." },
      { day: 3, title: "Gurudongmar Lake", desc: "Pre-dawn ascent to the 17,800ft sacred lake; return to Lachen/Lachung." },
      { day: 4, title: "Yumthang Valley", desc: "Valley of Flowers and Zero Point." },
      { day: 5, title: "Return to Gangtok", desc: "Drive back to the capital." },
      { day: 6, title: "Tsomgo Lake", desc: "Day trip to Tsomgo Lake and Baba Mandir." },
      { day: 7, title: "Departure", desc: "Transfer to Bagdogra/NJP." },
    ], INC_NE, EXC_NE),
  mk("sikkim", "Sikkim", 0, "sikkim-west-pelling-kanchenjunga", "West Sikkim & Pelling", "4 Nights / 5 Days", ["Pelling", "Pemayangtse", "Skywalk"],
    "Front-row Kanchenjunga views, ancient monasteries and the glass Skywalk at Pelling.",
    "The quieter west — Pelling's Kanchenjunga panoramas, Pemayangtse Monastery and the Skywalk.",
    [
      { day: 1, title: "Arrive Pelling", desc: "Transfer from Bagdogra/NJP to the hill town of Pelling." },
      { day: 2, title: "Pelling sightseeing", desc: "Pemayangtse Monastery, Rabdentse ruins and Kanchenjunga Falls." },
      { day: 3, title: "Skywalk & Char Dham", desc: "The glass Skywalk and the Char Dham complex at Namchi." },
      { day: 4, title: "Ravangla & Buddha Park", desc: "Ralang Monastery and the giant Buddha statue at Ravangla." },
      { day: 5, title: "Departure", desc: "Transfer to Bagdogra/NJP." },
    ], INC_NE, EXC_NE),
  mk("sikkim", "Sikkim", 1, "sikkim-silk-route-zuluk", "Silk Route & Zuluk", "5 Nights / 6 Days", ["Zuluk", "Silk Route", "Nathang"],
    "The old Silk Route's hairpin bends at Zuluk and the high Nathang Valley.",
    "Retrace the historic Silk Route through Zuluk's famous zig-zag road and the Nathang grasslands.",
    [
      { day: 1, title: "Arrive & drive to Zuluk", desc: "Transfer from NJP to the Silk Route hamlet of Zuluk." },
      { day: 2, title: "Zuluk to Nathang", desc: "Thambi Viewpoint's zig-zags, Lungthung and the Nathang Valley." },
      { day: 3, title: "Old Baba Mandir & Kupup", desc: "Kupup Lake, the old Baba Mandir and the world's highest golf course." },
      { day: 4, title: "To Gangtok", desc: "Descend to the capital via Tsomgo Lake." },
      { day: 5, title: "Gangtok sightseeing", desc: "Rumtek Monastery and city viewpoints." },
      { day: 6, title: "Departure", desc: "Transfer to Bagdogra/NJP." },
    ], INC_NE, EXC_NE),
  mk("sikkim", "Sikkim", 0, "sikkim-ravangla-namchi", "Ravangla & Namchi Spiritual Circuit", "4 Nights / 5 Days", ["Ravangla", "Namchi", "Buddha Park"],
    "Sikkim's spiritual south — giant statues, hilltop monasteries and tea gardens.",
    "A gentle spiritual circuit through Ravangla's Buddha Park, Namchi's Char Dham and Temi tea gardens.",
    [
      { day: 1, title: "Arrive Ravangla", desc: "Transfer from NJP to Ravangla; evening at the Buddha Park." },
      { day: 2, title: "Ralang & Maenam", desc: "Ralang Monastery and a short walk toward Maenam viewpoint." },
      { day: 3, title: "Namchi Char Dham", desc: "The Char Dham complex and the Samdruptse Guru statue." },
      { day: 4, title: "Temi Tea Garden", desc: "Sikkim's only tea estate and scenic drives." },
      { day: 5, title: "Departure", desc: "Transfer to Bagdogra/NJP." },
    ], INC_NE, EXC_NE),
  mk("sikkim", "Sikkim", 1, "sikkim-goecha-la-trek", "Goecha La Trek", "9 Nights / 10 Days", ["Trek", "Kanchenjunga", "Dzongri"],
    "The classic high Himalayan trek to the Goecha La pass beneath Kanchenjunga.",
    "Sikkim's flagship trek — from Yuksom through Dzongri to the Goecha La viewpoint under Kanchenjunga.",
    [
      { day: 1, title: "Arrive Yuksom", desc: "Transfer from NJP to the trailhead village of Yuksom." },
      { day: 2, title: "Yuksom to Sachen", desc: "Forest trail along the Rathong river." },
      { day: 3, title: "Sachen to Tshoka", desc: "Climb through rhododendron forest to Tshoka." },
      { day: 4, title: "Tshoka to Dzongri", desc: "Ascend to the alpine meadows of Dzongri." },
      { day: 5, title: "Dzongri Top & acclimatise", desc: "Sunrise from Dzongri Top; rest and acclimatise." },
      { day: 6, title: "Dzongri to Thansing", desc: "Descend and traverse to Thansing." },
      { day: 7, title: "Goecha La viewpoint", desc: "Pre-dawn push to View Point 1 beneath Kanchenjunga; return." },
      { day: 8, title: "Thansing to Tshoka", desc: "Long descent back through the forest." },
      { day: 9, title: "Tshoka to Yuksom", desc: "Final descent to the trailhead." },
      { day: 10, title: "Departure", desc: "Transfer to Bagdogra/NJP." },
    ], INC_NE, EXC_NE),
  mk("sikkim", "Sikkim", 0, "sikkim-honeymoon-special", "Sikkim Honeymoon Special", "6 Nights / 7 Days", ["Honeymoon", "Gangtok", "Pelling"],
    "A romantic mountain escape across Gangtok, Lachung and Pelling.",
    "A romantic tour pairing Gangtok and North Sikkim's snow valleys with the Kanchenjunga views of Pelling.",
    [
      { day: 1, title: "Arrive Gangtok", desc: "Transfer from the plains; candle-lit welcome." },
      { day: 2, title: "Tsomgo Lake", desc: "Glacial lake and Baba Mandir day trip." },
      { day: 3, title: "Drive to Lachung", desc: "Waterfall-lined drive into the snow valleys." },
      { day: 4, title: "Yumthang Valley", desc: "Valley of Flowers and Zero Point; return to Gangtok." },
      { day: 5, title: "Drive to Pelling", desc: "Cross-state drive to the west with Kanchenjunga views." },
      { day: 6, title: "Pelling", desc: "Pemayangtse Monastery, Skywalk and Kanchenjunga Falls." },
      { day: 7, title: "Departure", desc: "Transfer to Bagdogra/NJP." },
    ], INC_NE, EXC_NE),
  mk("sikkim", "Sikkim", 1, "sikkim-complete-grand", "Complete Sikkim Grand Tour", "8 Nights / 9 Days", ["Gangtok", "North Sikkim", "Pelling", "Ravangla"],
    "East, north and west Sikkim in one comprehensive grand circuit.",
    "The definitive Sikkim tour linking Gangtok, North Sikkim, Pelling and Ravangla into one grand loop.",
    [
      { day: 1, title: "Arrive Gangtok", desc: "Transfer from the plains; MG Marg evening." },
      { day: 2, title: "Tsomgo Lake", desc: "Glacial lake and Baba Mandir." },
      { day: 3, title: "To Lachung", desc: "Drive into North Sikkim." },
      { day: 4, title: "Yumthang Valley", desc: "Valley of Flowers and Zero Point." },
      { day: 5, title: "Return to Gangtok", desc: "Drive back; Rumtek Monastery." },
      { day: 6, title: "To Pelling", desc: "Cross to the west with Kanchenjunga panoramas." },
      { day: 7, title: "Pelling & Skywalk", desc: "Pemayangtse, Rabdentse and the Skywalk." },
      { day: 8, title: "Ravangla & Namchi", desc: "Buddha Park and the Char Dham." },
      { day: 9, title: "Departure", desc: "Transfer to Bagdogra/NJP." },
    ], INC_NE, EXC_NE),
  mk("sikkim", "Sikkim", 0, "sikkim-darjeeling-combo", "Darjeeling & Gangtok Combo", "6 Nights / 7 Days", ["Darjeeling", "Gangtok", "Tiger Hill"],
    "Two Himalayan icons — the tea slopes of Darjeeling and the buzz of Gangtok.",
    "Pair the Queen of Hills with the Sikkimese capital — Tiger Hill sunrise, tea gardens and Tsomgo Lake.",
    [
      { day: 1, title: "Arrive Darjeeling", desc: "Transfer from Bagdogra/NJP to Darjeeling." },
      { day: 2, title: "Tiger Hill & Ghum", desc: "Sunrise over Kanchenjunga, Batasia Loop and the toy train." },
      { day: 3, title: "Tea gardens", desc: "Tour a heritage tea estate and Darjeeling town." },
      { day: 4, title: "Drive to Gangtok", desc: "Scenic transfer into Sikkim." },
      { day: 5, title: "Tsomgo Lake", desc: "Glacial lake and Baba Mandir day trip." },
      { day: 6, title: "Gangtok sightseeing", desc: "Rumtek Monastery and city viewpoints." },
      { day: 7, title: "Departure", desc: "Transfer to Bagdogra/NJP." },
    ], INC_NE, EXC_NE),
  mk("sikkim", "Sikkim", 1, "sikkim-monasteries-heritage", "Monasteries & Heritage Trail", "5 Nights / 6 Days", ["Monasteries", "Rumtek", "Pemayangtse"],
    "A Buddhist heritage trail through Sikkim's most revered monasteries.",
    "Follow Sikkim's monastic heritage from Rumtek and Ranka to Pemayangtse and Tashiding.",
    [
      { day: 1, title: "Arrive Gangtok", desc: "Transfer from the plains; evening at leisure." },
      { day: 2, title: "Rumtek & Ranka", desc: "The seat of the Karmapa at Rumtek and the Ranka Monastery." },
      { day: 3, title: "To Pelling", desc: "Drive west via Ravangla's Buddha Park." },
      { day: 4, title: "Pemayangtse & Sanga Choeling", desc: "Two of Sikkim's oldest gompas near Pelling." },
      { day: 5, title: "Tashiding Monastery", desc: "The sacred Tashiding Monastery on its forested ridge." },
      { day: 6, title: "Departure", desc: "Transfer to Bagdogra/NJP." },
    ], INC_NE, EXC_NE),

  // ---------------- ARUNACHAL PRADESH ----------------
  mk("arunachal", "Arunachal Pradesh", 0, "arunachal-tawang-monastery", "Tawang Monastery Circuit", "7 Nights / 8 Days", ["Tawang", "Sela Pass", "Dirang"],
    "India's largest monastery at Tawang, reached across the 13,700ft Sela Pass.",
    "The classic overland journey to Tawang Monastery via the Dirang valley and the dramatic Sela Pass.",
    [
      { day: 1, title: "Arrive Guwahati/Tezpur", desc: "Meet on arrival; overnight in Tezpur." },
      { day: 2, title: "To Dirang", desc: "Enter Arunachal (permits) via Bhalukpong and Bomdila to Dirang." },
      { day: 3, title: "Sela Pass to Tawang", desc: "Cross the 13,700ft Sela Pass and Jaswant Garh to Tawang." },
      { day: 4, title: "Tawang Monastery", desc: "India's largest monastery and the Tawang war memorial." },
      { day: 5, title: "Bumla & Madhuri Lake", desc: "Bumla region and the Sangetsar (Madhuri) Lake." },
      { day: 6, title: "Return to Dirang/Bomdila", desc: "Recross Sela to Bomdila's gompa and apple orchards." },
      { day: 7, title: "To Tezpur", desc: "Descend along the Kameng river to the plains." },
      { day: 8, title: "Departure", desc: "Transfer to Guwahati/Tezpur." },
    ], INC_NE, EXC_NE),
  mk("arunachal", "Arunachal Pradesh", 1, "arunachal-sela-pass-bumla", "Sela Pass & Bumla Frontier", "6 Nights / 7 Days", ["Sela Pass", "Bumla", "Frontier"],
    "High passes and frontier lakes on the road to the Bumla border region.",
    "A frontier-focused route over Sela Pass to Tawang, Bumla and the glacial high-altitude lakes.",
    [
      { day: 1, title: "Arrive Tezpur", desc: "Meet on arrival; overnight in Tezpur." },
      { day: 2, title: "To Dirang", desc: "Enter Arunachal via Bomdila to the Dirang valley." },
      { day: 3, title: "Sela Pass to Tawang", desc: "Cross Sela Pass and Sela Lake to Tawang." },
      { day: 4, title: "Bumla & PTSO Lake", desc: "The Bumla frontier region and the PTSO/Madhuri lakes." },
      { day: 5, title: "Tawang town", desc: "Tawang Monastery, craft centre and war memorial." },
      { day: 6, title: "Return to Bomdila", desc: "Recross Sela; Bomdila viewpoints." },
      { day: 7, title: "Departure", desc: "Descend and transfer to Tezpur/Guwahati." },
    ], INC_NE, EXC_NE),
  mk("arunachal", "Arunachal Pradesh", 0, "arunachal-ziro-apatani", "Ziro Valley & Apatani Immersion", "5 Nights / 6 Days", ["Ziro", "Apatani", "Talley Valley"],
    "The rice-fish paddies and pine ridges of the Apatani in the UNESCO-tentative Ziro valley.",
    "A cultural immersion into Ziro's Apatani villages, Talley Valley pines and ridge-top viewpoints.",
    [
      { day: 1, title: "Arrive Itanagar", desc: "Meet at Naharlagun; overnight in the capital region." },
      { day: 2, title: "Drive to Ziro", desc: "Scenic hill drive into the Ziro valley." },
      { day: 3, title: "Apatani villages", desc: "Hong and Hija villages and the rice-fish paddies." },
      { day: 4, title: "Talley Valley", desc: "Nature walk in the pine-and-fern sanctuary." },
      { day: 5, title: "Kile Pakho ridge", desc: "Ridge viewpoint and a cultural evening." },
      { day: 6, title: "Departure", desc: "Drive to Naharlagun/Lilabari for onward travel." },
    ], INC_NE, EXC_NE),
  mk("arunachal", "Arunachal Pradesh", 1, "arunachal-mechuka-frontier", "Mechuka Frontier Valley", "6 Nights / 7 Days", ["Mechuka", "Monastery", "Siang"],
    "A remote Buddhist valley near the Tibet border, cradled by pine ridges and turquoise rivers.",
    "A deep-frontier journey to the little-visited Mechuka valley with its 400-year-old monastery.",
    [
      { day: 1, title: "Arrive Dibrugarh", desc: "Meet on arrival; overnight in Assam." },
      { day: 2, title: "To Aalo (Along)", desc: "Cross into Arunachal and drive to Aalo." },
      { day: 3, title: "Aalo to Mechuka", desc: "Spectacular mountain drive into the Mechuka valley." },
      { day: 4, title: "Mechuka villages", desc: "Samten Yongcha Monastery and Memba villages." },
      { day: 5, title: "Valley walks", desc: "Riverside walks and the frontier viewpoints." },
      { day: 6, title: "Return to Aalo", desc: "Drive back down the valley." },
      { day: 7, title: "Departure", desc: "Transfer to Dibrugarh." },
    ], INC_NE, EXC_NE),
  mk("arunachal", "Arunachal Pradesh", 0, "arunachal-dirang-bomdila", "Dirang & Bomdila Highlands", "5 Nights / 6 Days", ["Dirang", "Bomdila", "Hot Springs"],
    "Apple orchards, hot springs and hilltop gompas in the gentle western highlands.",
    "A relaxed highland tour of Dirang and Bomdila — monasteries, hot springs and apple country.",
    [
      { day: 1, title: "Arrive Tezpur", desc: "Meet on arrival; overnight in Tezpur." },
      { day: 2, title: "To Bomdila", desc: "Enter Arunachal via Bhalukpong; Bomdila monastery." },
      { day: 3, title: "Dirang valley", desc: "Dirang Dzong, hot springs and the National Yak Research Centre." },
      { day: 4, title: "Sangti Valley", desc: "The tranquil Sangti Valley and its migratory birds." },
      { day: 5, title: "Return to Tezpur", desc: "Descend along the Kameng river." },
      { day: 6, title: "Departure", desc: "Transfer to Guwahati/Tezpur." },
    ], INC_NE, EXC_NE),
  mk("arunachal", "Arunachal Pradesh", 1, "arunachal-namdapha-wildlife", "Namdapha Wildlife Expedition", "6 Nights / 7 Days", ["Namdapha", "Wildlife", "Miao"],
    "India's easternmost and most bio-diverse national park, home to four big cats.",
    "A wilderness expedition into Namdapha National Park's rainforest from Miao and Deban.",
    [
      { day: 1, title: "Arrive Dibrugarh", desc: "Meet on arrival; overnight in Assam." },
      { day: 2, title: "To Miao", desc: "Cross into Arunachal and drive to Miao (permits)." },
      { day: 3, title: "Miao to Deban", desc: "Enter Namdapha; riverside camp at Deban." },
      { day: 4, title: "Rainforest trails", desc: "Guided forest walks and birding along the Noa-Dihing." },
      { day: 5, title: "Hornbill & Firmbase", desc: "Deeper trails for hornbills and rare wildlife." },
      { day: 6, title: "Return to Miao", desc: "Exit the park; Miao museum and Buddhist village." },
      { day: 7, title: "Departure", desc: "Transfer to Dibrugarh." },
    ], INC_NE, EXC_NE),
  mk("arunachal", "Arunachal Pradesh", 0, "arunachal-pasighat-siang", "Pasighat & the Siang", "5 Nights / 6 Days", ["Pasighat", "Siang River", "Adi"],
    "Arunachal's oldest town where the mighty Siang (Brahmaputra) enters the plains.",
    "A river-country journey around Pasighat, the Siang gorge and the Adi tribal heartland.",
    [
      { day: 1, title: "Arrive Dibrugarh", desc: "Meet on arrival; overnight in Assam." },
      { day: 2, title: "To Pasighat", desc: "Cross into Arunachal; the Siang riverfront." },
      { day: 3, title: "Siang & Adi villages", desc: "Kekar Monying cliff, hanging bridges and Adi villages." },
      { day: 4, title: "Daporijo / Aalo side-trip", desc: "Explore upriver villages and tribal culture." },
      { day: 5, title: "Return to Pasighat", desc: "River views and local markets." },
      { day: 6, title: "Departure", desc: "Transfer to Dibrugarh." },
    ], INC_NE, EXC_NE),
  mk("arunachal", "Arunachal Pradesh", 1, "arunachal-anini-dibang", "Anini & Dibang Valley", "6 Nights / 7 Days", ["Anini", "Dibang", "Idu Mishmi"],
    "One of India's remotest districts — the pristine Dibang Valley and Idu Mishmi culture.",
    "An expedition to the far-flung Anini and the untouched Dibang Valley wilderness.",
    [
      { day: 1, title: "Arrive Dibrugarh", desc: "Meet on arrival; overnight in Assam." },
      { day: 2, title: "To Roing", desc: "Cross into Arunachal; the Mehao Lake area." },
      { day: 3, title: "Roing to Anini", desc: "Long, spectacular climb into the Dibang Valley." },
      { day: 4, title: "Anini", desc: "Idu Mishmi villages and river confluences." },
      { day: 5, title: "Return to Roing", desc: "Descend through the valley." },
      { day: 6, title: "Roing sights", desc: "Mehao Wildlife Sanctuary and Bhismaknagar." },
      { day: 7, title: "Departure", desc: "Transfer to Dibrugarh." },
    ], INC_NE, EXC_NE),
  mk("arunachal", "Arunachal Pradesh", 0, "arunachal-roing-mayodia", "Roing & Mayodia Pass", "5 Nights / 6 Days", ["Roing", "Mayodia", "Snow"],
    "The snow-clad Mayodia Pass and the lakes and history around Roing.",
    "A short mountain circuit to the snowy Mayodia Pass with the lakes and ruins of Roing.",
    [
      { day: 1, title: "Arrive Dibrugarh", desc: "Meet on arrival; overnight in Assam." },
      { day: 2, title: "To Roing", desc: "Cross into Arunachal; Mehao Lake." },
      { day: 3, title: "Mayodia Pass", desc: "Drive up to the snow-clad Mayodia Pass and back." },
      { day: 4, title: "Roing heritage", desc: "Bhismaknagar fort ruins and tribal villages." },
      { day: 5, title: "Return toward Assam", desc: "Descend to the plains." },
      { day: 6, title: "Departure", desc: "Transfer to Dibrugarh." },
    ], INC_NE, EXC_NE),
  mk("arunachal", "Arunachal Pradesh", 1, "arunachal-tuting-yingkiong", "Tuting & Upper Siang", "6 Nights / 7 Days", ["Tuting", "Upper Siang", "Rafting"],
    "The Brahmaputra's entry point into India and the wild Upper Siang gorges.",
    "A remote river journey to Tuting and Yingkiong, where the Tsangpo becomes the Siang.",
    [
      { day: 1, title: "Arrive Dibrugarh", desc: "Meet on arrival; overnight in Assam." },
      { day: 2, title: "To Pasighat", desc: "Cross into Arunachal; the Siang riverfront." },
      { day: 3, title: "To Yingkiong", desc: "Drive upriver into the Upper Siang district." },
      { day: 4, title: "Tuting", desc: "The frontier village where the Siang enters India." },
      { day: 5, title: "Villages & gorges", desc: "Adi/Memba villages and dramatic river gorges." },
      { day: 6, title: "Return to Pasighat", desc: "Descend along the Siang." },
      { day: 7, title: "Departure", desc: "Transfer to Dibrugarh." },
    ], INC_NE, EXC_NE),
  mk("arunachal", "Arunachal Pradesh", 0, "arunachal-complete-west", "Complete West Arunachal", "9 Nights / 10 Days", ["Tawang", "Dirang", "Ziro"],
    "West Arunachal in depth — Tawang, the Sela highlands and the Ziro valley.",
    "A comprehensive west-Arunachal grand tour linking Tawang, Dirang, Bomdila and Ziro.",
    [
      { day: 1, title: "Arrive Guwahati", desc: "Meet on arrival; overnight." },
      { day: 2, title: "To Dirang", desc: "Enter Arunachal via Bomdila." },
      { day: 3, title: "Sela to Tawang", desc: "Cross the 13,700ft Sela Pass to Tawang." },
      { day: 4, title: "Tawang", desc: "Monastery, Bumla and Madhuri Lake." },
      { day: 5, title: "To Bomdila", desc: "Recross Sela; Bomdila gompa." },
      { day: 6, title: "To Itanagar", desc: "Long transfer toward the capital." },
      { day: 7, title: "Drive to Ziro", desc: "Into the Apatani valley." },
      { day: 8, title: "Ziro villages", desc: "Apatani villages and Talley Valley." },
      { day: 9, title: "To the plains", desc: "Descend toward Lilabari/Naharlagun." },
      { day: 10, title: "Departure", desc: "Transfer for your onward flight." },
    ], INC_NE, EXC_NE),
  mk("arunachal", "Arunachal Pradesh", 1, "arunachal-tribal-culture", "Tribal Culture & Festivals", "6 Nights / 7 Days", ["Tribes", "Festivals", "Culture"],
    "Meet the Monpa, Apatani, Adi and Nyishi peoples and their vivid festivals.",
    "A culture-first journey through Arunachal's tribal heartlands and seasonal festivals.",
    [
      { day: 1, title: "Arrive Itanagar", desc: "Ita Fort and the Jawaharlal Nehru Museum." },
      { day: 2, title: "Nyishi villages", desc: "Nyishi culture around the capital region." },
      { day: 3, title: "Drive to Ziro", desc: "Into the Apatani valley." },
      { day: 4, title: "Apatani immersion", desc: "Village homestays and rice-fish farming." },
      { day: 5, title: "Daporijo / Adi belt", desc: "Adi and Tagin villages upriver." },
      { day: 6, title: "Return to Itanagar", desc: "Craft markets and cultural evening." },
      { day: 7, title: "Departure", desc: "Transfer for your onward journey." },
    ], INC_NE, EXC_NE),

  // ---------------- MEGHALAYA ----------------
  mk("meghalaya", "Meghalaya", 0, "meghalaya-shillong-cherrapunji", "Shillong & Cherrapunji", "4 Nights / 5 Days", ["Shillong", "Cherrapunji", "Waterfalls"],
    "The Scotland of the East and the waterfall country of Cherrapunji.",
    "A classic short break through Shillong's charm and the thundering waterfalls of Cherrapunji.",
    [
      { day: 1, title: "Arrive Shillong", desc: "Drive from Guwahati; Ward's Lake and Police Bazaar." },
      { day: 2, title: "Cherrapunji circuit", desc: "Nohkalikai Falls, Mawsmai caves and Seven Sisters Falls." },
      { day: 3, title: "Mawlynnong & Dawki", desc: "Asia's cleanest village and the clear Umngot river." },
      { day: 4, title: "Shillong leisure", desc: "Elephant Falls, Shillong Peak and café culture." },
      { day: 5, title: "Departure", desc: "Transfer to Guwahati." },
    ], INC_NE, EXC_NE),
  mk("meghalaya", "Meghalaya", 1, "meghalaya-root-bridges-nongriat", "Living Root Bridges Trek", "5 Nights / 6 Days", ["Root Bridges", "Nongriat", "Trek"],
    "Trek to the famous double-decker living-root bridge at Nongriat.",
    "A trekking-focused tour to the double-decker living-root bridge and natural pools of Nongriat.",
    [
      { day: 1, title: "Arrive Shillong", desc: "Drive from Guwahati; evening at leisure." },
      { day: 2, title: "To Cherrapunji", desc: "Waterfalls circuit and the trailhead at Tyrna." },
      { day: 3, title: "Nongriat trek", desc: "Descend ~3,500 steps to the double-decker bridge; overnight homestay." },
      { day: 4, title: "Rainbow Falls & climb out", desc: "Hike to Rainbow Falls, then climb back to Tyrna." },
      { day: 5, title: "Mawlynnong & Dawki", desc: "Cleanest village and the Umngot river." },
      { day: 6, title: "Departure", desc: "Transfer to Guwahati." },
    ], INC_NE, EXC_NE),
  mk("meghalaya", "Meghalaya", 0, "meghalaya-dawki-mawlynnong", "Dawki & Mawlynnong", "4 Nights / 5 Days", ["Dawki", "Mawlynnong", "Umngot"],
    "Boat over the glass-clear Umngot river and visit Asia's cleanest village.",
    "A gentle tour of the border country — Mawlynnong's cleanliness and the transparent Umngot at Dawki.",
    [
      { day: 1, title: "Arrive Shillong", desc: "Drive from Guwahati; Ward's Lake." },
      { day: 2, title: "Mawlynnong", desc: "Asia's cleanest village, sky-walk and living-root bridge." },
      { day: 3, title: "Dawki & Umngot", desc: "Boat ride on the crystal-clear Umngot river at the frontier." },
      { day: 4, title: "Cherrapunji", desc: "Nohkalikai Falls and Mawsmai caves." },
      { day: 5, title: "Departure", desc: "Transfer to Guwahati." },
    ], INC_NE, EXC_NE),
  mk("meghalaya", "Meghalaya", 1, "meghalaya-mawsynram-caves", "Mawsynram & Caves", "5 Nights / 6 Days", ["Mawsynram", "Caves", "Cherrapunji"],
    "The wettest place on earth and Meghalaya's dramatic limestone caves.",
    "An explorer's tour of Mawsynram, the Mawjymbuin cave and Cherrapunji's caverns and canyons.",
    [
      { day: 1, title: "Arrive Shillong", desc: "Drive from Guwahati; evening at leisure." },
      { day: 2, title: "Mawsynram", desc: "The wettest place on earth and the Mawjymbuin cave." },
      { day: 3, title: "Cherrapunji caves", desc: "Mawsmai and Arwah caves; Nohkalikai Falls." },
      { day: 4, title: "Laitlum Canyon", desc: "The dramatic Laitlum Canyon and Smit village." },
      { day: 5, title: "Dawki & Mawlynnong", desc: "Umngot river and the cleanest village." },
      { day: 6, title: "Departure", desc: "Transfer to Guwahati." },
    ], INC_NE, EXC_NE),
  mk("meghalaya", "Meghalaya", 0, "meghalaya-laitlum-canyons", "Laitlum Canyons & East Khasi", "4 Nights / 5 Days", ["Laitlum", "Smit", "East Khasi"],
    "The jaw-dropping Laitlum Canyon and the cultural villages of the East Khasi hills.",
    "A scenic-and-cultural tour of the East Khasi hills, from Laitlum Canyon to Smit's heritage.",
    [
      { day: 1, title: "Arrive Shillong", desc: "Drive from Guwahati; Ward's Lake." },
      { day: 2, title: "Laitlum Canyon", desc: "The sweeping canyon views and a village descent." },
      { day: 3, title: "Smit & Mawphlang", desc: "Khasi heritage at Smit and the Mawphlang sacred forest." },
      { day: 4, title: "Cherrapunji", desc: "Waterfalls and viewpoints." },
      { day: 5, title: "Departure", desc: "Transfer to Guwahati." },
    ], INC_NE, EXC_NE),
  mk("meghalaya", "Meghalaya", 1, "meghalaya-garo-hills", "Garo Hills Wilderness", "5 Nights / 6 Days", ["Garo Hills", "Balpakram", "Tura"],
    "The wild, forested Garo Hills and the 'land of spirits' at Balpakram.",
    "An off-the-map tour of the western Garo Hills — Tura peak, Nokrek and Balpakram National Park.",
    [
      { day: 1, title: "Arrive Guwahati", desc: "Meet on arrival; overnight." },
      { day: 2, title: "To Tura", desc: "Long scenic drive into the Garo Hills." },
      { day: 3, title: "Tura & Nokrek", desc: "Tura Peak and the edge of Nokrek Biosphere Reserve." },
      { day: 4, title: "Balpakram", desc: "The 'land of spirits' — Balpakram National Park's canyons." },
      { day: 5, title: "Siju caves", desc: "The Siju limestone caves and river country." },
      { day: 6, title: "Departure", desc: "Return drive to Guwahati." },
    ], INC_NE, EXC_NE),
  mk("meghalaya", "Meghalaya", 0, "meghalaya-jaintia-hills", "Jaintia Hills Heritage", "4 Nights / 5 Days", ["Jaintia", "Nartiang", "Monoliths"],
    "Ancient monoliths, cave country and the Jaintia kingdom's heritage.",
    "A heritage tour of the Jaintia Hills — Nartiang's monoliths, Krang Suri Falls and cave country.",
    [
      { day: 1, title: "Arrive Shillong", desc: "Drive from Guwahati; evening at leisure." },
      { day: 2, title: "Nartiang", desc: "The Nartiang monoliths and Durga temple." },
      { day: 3, title: "Krang Suri & Jowai", desc: "The turquoise Krang Suri Falls and Jowai town." },
      { day: 4, title: "Cave country", desc: "Explore a Jaintia limestone cave and river pools." },
      { day: 5, title: "Departure", desc: "Transfer to Guwahati." },
    ], INC_NE, EXC_NE),
  mk("meghalaya", "Meghalaya", 1, "meghalaya-nongkhnum-island", "Nongkhnum River Island", "5 Nights / 6 Days", ["Nongkhnum", "West Khasi", "Falls"],
    "Meghalaya's largest river island and the quiet West Khasi hills.",
    "A tranquil escape to Nongkhnum, India's second-largest river island, and the West Khasi hills.",
    [
      { day: 1, title: "Arrive Shillong", desc: "Drive from Guwahati; Ward's Lake." },
      { day: 2, title: "To Nongstoin", desc: "Drive into the West Khasi hills." },
      { day: 3, title: "Nongkhnum Island", desc: "The river island, Langshiang Falls and sandbanks." },
      { day: 4, title: "Kynrem & Mawthadraishan", desc: "Waterfalls and ridge viewpoints." },
      { day: 5, title: "Return to Shillong", desc: "Drive back with photo stops." },
      { day: 6, title: "Departure", desc: "Transfer to Guwahati." },
    ], INC_NE, EXC_NE),
  mk("meghalaya", "Meghalaya", 0, "meghalaya-mawphlang-sacred-forest", "Mawphlang Sacred Forest", "3 Nights / 4 Days", ["Mawphlang", "Sacred Forest", "David Scott Trail"],
    "The sacred grove of Mawphlang and a walk along the historic David Scott Trail.",
    "A short nature-and-culture break around Mawphlang's sacred forest and the David Scott Trail.",
    [
      { day: 1, title: "Arrive Shillong", desc: "Drive from Guwahati; evening at leisure." },
      { day: 2, title: "Mawphlang sacred forest", desc: "Guided walk through the protected Khasi sacred grove." },
      { day: 3, title: "David Scott Trail", desc: "A scenic section of the historic 19th-century trail." },
      { day: 4, title: "Departure", desc: "Transfer to Guwahati." },
    ], INC_NE, EXC_NE),
  mk("meghalaya", "Meghalaya", 1, "meghalaya-complete-grand", "Complete Meghalaya Grand", "7 Nights / 8 Days", ["Shillong", "Cherrapunji", "Dawki", "Jaintia"],
    "Every corner of the abode of clouds in one comprehensive tour.",
    "The definitive Meghalaya tour — Shillong, Cherrapunji, Dawki, Nongriat and the Jaintia Hills.",
    [
      { day: 1, title: "Arrive Shillong", desc: "Drive from Guwahati; Ward's Lake." },
      { day: 2, title: "Cherrapunji", desc: "Nohkalikai Falls, caves and viewpoints." },
      { day: 3, title: "Nongriat trek", desc: "Double-decker living-root bridge trek." },
      { day: 4, title: "Mawlynnong & Dawki", desc: "Cleanest village and the Umngot river." },
      { day: 5, title: "Laitlum & Mawphlang", desc: "Canyon views and the sacred forest." },
      { day: 6, title: "Jaintia Hills", desc: "Nartiang monoliths and Krang Suri Falls." },
      { day: 7, title: "Shillong leisure", desc: "Markets and café culture." },
      { day: 8, title: "Departure", desc: "Transfer to Guwahati." },
    ], INC_NE, EXC_NE),
  mk("meghalaya", "Meghalaya", 0, "meghalaya-monsoon-waterfalls", "Monsoon Waterfalls Special", "4 Nights / 5 Days", ["Monsoon", "Waterfalls", "Cherrapunji"],
    "The abode of clouds at its most dramatic — thundering monsoon waterfalls.",
    "A monsoon-season tour built around Meghalaya's most spectacular waterfalls in full flow.",
    [
      { day: 1, title: "Arrive Shillong", desc: "Drive from Guwahati; misty first evening." },
      { day: 2, title: "Cherrapunji falls", desc: "Nohkalikai, Seven Sisters and Wei Sawdong in full flow." },
      { day: 3, title: "Krang Suri & Jaintia", desc: "The turquoise Krang Suri Falls and cave country." },
      { day: 4, title: "Elephant & Sweet Falls", desc: "Shillong's waterfalls and viewpoints." },
      { day: 5, title: "Departure", desc: "Transfer to Guwahati." },
    ], INC_NE, EXC_NE),
  mk("meghalaya", "Meghalaya", 1, "meghalaya-assam-combo", "Meghalaya & Kaziranga Combo", "6 Nights / 7 Days", ["Meghalaya", "Kaziranga", "Rhinos"],
    "Cloud forests and one-horned rhinos — Meghalaya paired with Kaziranga.",
    "A best-of-both tour combining Meghalaya's highlights with Kaziranga's famous rhino safaris.",
    [
      { day: 1, title: "Arrive Guwahati", desc: "Kamakhya temple and Brahmaputra sunset." },
      { day: 2, title: "To Kaziranga", desc: "Drive to the national park." },
      { day: 3, title: "Kaziranga safaris", desc: "Jeep safaris for rhino, elephant and deer." },
      { day: 4, title: "To Shillong", desc: "Drive into Meghalaya via Umiam Lake." },
      { day: 5, title: "Cherrapunji", desc: "Waterfalls and living-root bridge country." },
      { day: 6, title: "Dawki & Mawlynnong", desc: "Umngot river and cleanest village." },
      { day: 7, title: "Departure", desc: "Transfer to Guwahati." },
    ], INC_NE, EXC_NE),

  // ---------------- BHUTAN ----------------
  mk("bhutan", "Bhutan", 0, "bhutan-paro-thimphu-punakha", "Paro, Thimphu & Punakha", "5 Nights / 6 Days", ["Paro", "Thimphu", "Punakha"],
    "The essential western Bhutan trio, ending at the sacred Tiger's Nest.",
    "The classic first-timer's Bhutan — Paro, the capital Thimphu, Punakha Dzong and Tiger's Nest.",
    [
      { day: 1, title: "Arrive Paro", desc: "Spectacular Himalayan landing; Rinpung Dzong and Paro town." },
      { day: 2, title: "Thimphu", desc: "Buddha Dordenma, Memorial Chorten and the capital's sights." },
      { day: 3, title: "Punakha via Dochula", desc: "Dochula Pass (108 chortens) and riverside Punakha Dzong." },
      { day: 4, title: "Return to Paro", desc: "Chimi Lhakhang walk; drive back to Paro." },
      { day: 5, title: "Tiger's Nest hike", desc: "The iconic 4–6 hour climb to Taktsang monastery." },
      { day: 6, title: "Departure", desc: "Transfer to Paro airport." },
    ], INC_BT, EXC_BT),
  mk("bhutan", "Bhutan", 1, "bhutan-tigers-nest-trek", "Tiger's Nest Pilgrimage", "4 Nights / 5 Days", ["Tiger's Nest", "Paro", "Taktsang"],
    "A focused short pilgrimage centred on Bhutan's iconic cliff monastery.",
    "A compact Bhutan break built around the sacred hike to the Tiger's Nest above Paro valley.",
    [
      { day: 1, title: "Arrive Paro", desc: "Rinpung Dzong and the National Museum." },
      { day: 2, title: "Thimphu day trip", desc: "Buddha Dordenma and the capital's highlights." },
      { day: 3, title: "Tiger's Nest hike", desc: "The 4–6 hour round-trip climb to Taktsang monastery." },
      { day: 4, title: "Paro valley", desc: "Kyichu Lhakhang and a farmhouse hot-stone bath." },
      { day: 5, title: "Departure", desc: "Transfer to Paro airport." },
    ], INC_BT, EXC_BT),
  mk("bhutan", "Bhutan", 0, "bhutan-phobjikha-gangtey", "Phobjikha & Gangtey Valley", "6 Nights / 7 Days", ["Phobjikha", "Gangtey", "Black-necked Cranes"],
    "The glacial Phobjikha valley, winter home of the rare black-necked cranes.",
    "A journey to the serene Phobjikha (Gangtey) valley, with Paro, Thimphu and Punakha en route.",
    [
      { day: 1, title: "Arrive Paro", desc: "Rinpung Dzong and Paro town." },
      { day: 2, title: "Thimphu", desc: "Buddha Dordenma and capital sights." },
      { day: 3, title: "Punakha", desc: "Dochula Pass and Punakha Dzong." },
      { day: 4, title: "To Phobjikha", desc: "Drive to the glacial Gangtey valley; Gangtey Gonpa." },
      { day: 5, title: "Phobjikha valley", desc: "Gangtey Nature Trail and crane-viewing (in season)." },
      { day: 6, title: "Return to Paro", desc: "Drive back west with valley views." },
      { day: 7, title: "Tiger's Nest & departure", desc: "Optional Taktsang hike; transfer to Paro airport." },
    ], INC_BT, EXC_BT),
  mk("bhutan", "Bhutan", 1, "bhutan-bumthang-central", "Central Bhutan & Bumthang", "8 Nights / 9 Days", ["Bumthang", "Trongsa", "Central Bhutan"],
    "Bhutan's spiritual heartland — the sacred temples and valleys of Bumthang.",
    "A deep central-Bhutan tour to Trongsa and the four sacred valleys of Bumthang.",
    [
      { day: 1, title: "Arrive Paro", desc: "Rinpung Dzong and Paro town." },
      { day: 2, title: "Thimphu", desc: "Buddha Dordenma and capital sights." },
      { day: 3, title: "Punakha", desc: "Dochula Pass and Punakha Dzong." },
      { day: 4, title: "To Trongsa", desc: "Cross Pele La to the commanding Trongsa Dzong." },
      { day: 5, title: "To Bumthang", desc: "Drive to the Bumthang valleys." },
      { day: 6, title: "Bumthang temples", desc: "Jakar Dzong, Jambay and Kurjey Lhakhang." },
      { day: 7, title: "Tang & Ura valleys", desc: "Membartsho (burning lake) and highland villages." },
      { day: 8, title: "Return west", desc: "Long drive back toward Paro." },
      { day: 9, title: "Departure", desc: "Transfer to Paro airport." },
    ], INC_BT, EXC_BT),
  mk("bhutan", "Bhutan", 0, "bhutan-haa-valley", "Haa Valley & Chele La", "6 Nights / 7 Days", ["Haa Valley", "Chele La", "Paro"],
    "The hidden Haa valley reached over Bhutan's highest motorable pass, Chele La.",
    "A tour to the little-visited Haa valley across the Chele La pass, with Paro, Thimphu and Punakha.",
    [
      { day: 1, title: "Arrive Paro", desc: "Rinpung Dzong and Paro town." },
      { day: 2, title: "Thimphu", desc: "Buddha Dordenma and capital sights." },
      { day: 3, title: "Punakha", desc: "Dochula Pass and Punakha Dzong." },
      { day: 4, title: "To Haa via Chele La", desc: "Cross the 3,988m Chele La to the Haa valley." },
      { day: 5, title: "Haa valley", desc: "Lhakhang Karpo & Nagpo temples and village walks." },
      { day: 6, title: "Return to Paro", desc: "Tiger's Nest hike." },
      { day: 7, title: "Departure", desc: "Transfer to Paro airport." },
    ], INC_BT, EXC_BT),
  mk("bhutan", "Bhutan", 1, "bhutan-festival-tshechu", "Tshechu Festival Special", "5 Nights / 6 Days", ["Tshechu", "Festival", "Masked Dance"],
    "Time your visit to a colourful Bhutanese tshechu — masked dances and blessings.",
    "A festival-timed tour built around a Paro or Thimphu tshechu, with the region's key sights.",
    [
      { day: 1, title: "Arrive Paro", desc: "Rinpung Dzong and Paro town." },
      { day: 2, title: "Festival day", desc: "A full day of masked cham dances at the tshechu." },
      { day: 3, title: "Thimphu", desc: "Buddha Dordenma and capital sights." },
      { day: 4, title: "Punakha", desc: "Dochula Pass and Punakha Dzong." },
      { day: 5, title: "Tiger's Nest hike", desc: "The climb to Taktsang monastery." },
      { day: 6, title: "Departure", desc: "Transfer to Paro airport." },
    ], INC_BT, EXC_BT),
  mk("bhutan", "Bhutan", 0, "bhutan-druk-path-trek", "Druk Path Trek", "7 Nights / 8 Days", ["Trek", "Druk Path", "Alpine Lakes"],
    "Bhutan's most popular trek, over alpine lakes between Paro and Thimphu.",
    "The scenic Druk Path Trek across high ridges and glacial lakes from Paro to Thimphu.",
    [
      { day: 1, title: "Arrive Paro", desc: "Rinpung Dzong and Paro town." },
      { day: 2, title: "Tiger's Nest", desc: "Acclimatising hike to Taktsang monastery." },
      { day: 3, title: "Trek: Paro to Jele Dzong", desc: "Climb to the ridge camp near Jele Dzong." },
      { day: 4, title: "To Jangchulakha", desc: "High ridge walking with Himalayan views." },
      { day: 5, title: "To Jimilangtsho", desc: "Camp beside the trout-filled glacial lake." },
      { day: 6, title: "To Simkotra", desc: "Lakes, yak pastures and alpine passes." },
      { day: 7, title: "Descend to Thimphu", desc: "Final descent to the capital; celebration dinner." },
      { day: 8, title: "Departure", desc: "Transfer to Paro airport." },
    ], INC_BT, EXC_BT),
  mk("bhutan", "Bhutan", 1, "bhutan-honeymoon-luxury", "Bhutan Honeymoon Escape", "6 Nights / 7 Days", ["Honeymoon", "Luxury", "Punakha"],
    "A romantic Bhutan escape with intimate valleys and a farmhouse hot-stone bath.",
    "A romantic tour of western Bhutan with relaxed pacing, scenic valleys and special touches.",
    [
      { day: 1, title: "Arrive Paro", desc: "Rinpung Dzong; a candle-lit welcome dinner." },
      { day: 2, title: "Thimphu", desc: "Buddha Dordenma and capital sights." },
      { day: 3, title: "To Punakha", desc: "Dochula Pass; riverside Punakha Dzong." },
      { day: 4, title: "Punakha valley", desc: "Chimi Lhakhang (temple of fertility) and river walks." },
      { day: 5, title: "Return to Paro", desc: "Farmhouse dinner and hot-stone bath." },
      { day: 6, title: "Tiger's Nest hike", desc: "The climb to Taktsang monastery." },
      { day: 7, title: "Departure", desc: "Transfer to Paro airport." },
    ], INC_BT, EXC_BT),
  mk("bhutan", "Bhutan", 0, "bhutan-punakha-wangdue", "Punakha & Wangdue", "5 Nights / 6 Days", ["Punakha", "Wangdue", "Dzong"],
    "The sub-tropical valleys of Punakha and Wangdue and their grand dzongs.",
    "A tour focused on the warm Punakha–Wangdue valleys and their beautiful riverside dzongs.",
    [
      { day: 1, title: "Arrive Paro", desc: "Rinpung Dzong and Paro town." },
      { day: 2, title: "Thimphu", desc: "Buddha Dordenma and capital sights." },
      { day: 3, title: "To Punakha", desc: "Dochula Pass and Punakha Dzong." },
      { day: 4, title: "Wangdue & Chimi Lhakhang", desc: "Wangdue valley and the temple of fertility." },
      { day: 5, title: "Return to Paro", desc: "Tiger's Nest hike." },
      { day: 6, title: "Departure", desc: "Transfer to Paro airport." },
    ], INC_BT, EXC_BT),
  mk("bhutan", "Bhutan", 1, "bhutan-eastern-explorer", "Eastern Bhutan Explorer", "9 Nights / 10 Days", ["Eastern Bhutan", "Mongar", "Trashigang"],
    "The remote, rarely-visited east — Mongar, Trashigang and border valleys.",
    "An adventurous traverse deep into eastern Bhutan, ending near the Indian border at Samdrup Jongkhar.",
    [
      { day: 1, title: "Arrive Paro", desc: "Rinpung Dzong and Paro town." },
      { day: 2, title: "Thimphu", desc: "Capital sights." },
      { day: 3, title: "Punakha", desc: "Dochula Pass and Punakha Dzong." },
      { day: 4, title: "Trongsa", desc: "Cross Pele La to Trongsa Dzong." },
      { day: 5, title: "Bumthang", desc: "The sacred valleys and temples." },
      { day: 6, title: "To Mongar", desc: "Cross Thrumshing La into the east." },
      { day: 7, title: "Trashigang", desc: "The east's largest dzong and villages." },
      { day: 8, title: "Trashiyangtse", desc: "Chorten Kora and the Bomdeling valley." },
      { day: 9, title: "To Samdrup Jongkhar", desc: "Descend toward the Indian border." },
      { day: 10, title: "Departure", desc: "Exit via Samdrup Jongkhar / Guwahati." },
    ], INC_BT, EXC_BT),
  mk("bhutan", "Bhutan", 0, "bhutan-photography-tour", "Bhutan Photography Tour", "7 Nights / 8 Days", ["Photography", "Dzongs", "Landscapes"],
    "A slow, light-chasing tour of Bhutan's dzongs, valleys and festivals for photographers.",
    "A photography-paced tour timed for the best light on Bhutan's dzongs, valleys and daily life.",
    [
      { day: 1, title: "Arrive Paro", desc: "Golden-hour shoot at Rinpung Dzong." },
      { day: 2, title: "Thimphu", desc: "Buddha Dordenma and street life." },
      { day: 3, title: "Dochula & Punakha", desc: "Sunrise at Dochula's 108 chortens; Punakha Dzong." },
      { day: 4, title: "Phobjikha", desc: "The glacial valley and Gangtey Gonpa." },
      { day: 5, title: "Back to Paro", desc: "Village portraits en route." },
      { day: 6, title: "Tiger's Nest", desc: "The classic Taktsang composition." },
      { day: 7, title: "Paro valley", desc: "Rice terraces and farmhouse life." },
      { day: 8, title: "Departure", desc: "Transfer to Paro airport." },
    ], INC_BT, EXC_BT),
  mk("bhutan", "Bhutan", 1, "bhutan-complete-kingdom", "Complete Kingdom Grand Tour", "10 Nights / 11 Days", ["Grand Tour", "Bumthang", "Phobjikha"],
    "West and central Bhutan in depth — the definitive kingdom-wide grand tour.",
    "The most comprehensive Bhutan tour, weaving Paro, Thimphu, Punakha, Phobjikha and Bumthang.",
    [
      { day: 1, title: "Arrive Paro", desc: "Rinpung Dzong and Paro town." },
      { day: 2, title: "Thimphu", desc: "Buddha Dordenma and capital sights." },
      { day: 3, title: "Punakha", desc: "Dochula Pass and Punakha Dzong." },
      { day: 4, title: "Phobjikha", desc: "The glacial Gangtey valley." },
      { day: 5, title: "To Trongsa", desc: "Cross Pele La to Trongsa." },
      { day: 6, title: "Bumthang", desc: "The sacred valleys and temples." },
      { day: 7, title: "Tang valley", desc: "Membartsho and highland villages." },
      { day: 8, title: "Return to Punakha", desc: "Long westward drive." },
      { day: 9, title: "To Paro", desc: "Drive back to Paro; leisure." },
      { day: 10, title: "Tiger's Nest hike", desc: "The climb to Taktsang monastery." },
      { day: 11, title: "Departure", desc: "Transfer to Paro airport." },
    ], INC_BT, EXC_BT),
];

export const EXTRA_PACKAGES = DEFS.map((d) => d.list);
export const EXTRA_PACKAGE_DETAILS = DEFS.reduce((acc, d) => {
  acc[d.list.slug] = d.detail;
  return acc;
}, {});

// Sample-itinerary cards (name + days + route) for the four destination pages,
// derived from the packages above so each page shows 12 itinerary options.
function cardsFor(region) {
  return DEFS.filter((d) => d.list.region === region).map((d) => ({
    name: d.list.title,
    days: d.list.days,
    route: d.detail.itinerary.map((it) => it.title),
  }));
}

export const EXTRA_DEST_ITINERARIES = {
  sikkim: cardsFor("Sikkim"),
  "arunachal-pradesh": cardsFor("Arunachal Pradesh"),
  meghalaya: cardsFor("Meghalaya"),
  bhutan: cardsFor("Bhutan"),
};
